module.exports = __webpack_public_path__ + "static/media/mug-marshmallows.5af093cd.svg";